export const VALIDATE_NOT_EMPTY     = 'VALIDATE_NOT_EMPTY';
export const VALIDATE_MAX_LENGTH    = 'VALIDATE_MAX_LENGTH';
export const VALIDATE_MIN_LENGTH    = 'VALIDATE_MIN_LENGTH';
export const VALIDATE_EQUALS_FIELD  = 'VALIDATE_EQUALS_FIELD';
export const VALIDATE_EMAIL         = 'VALIDATE_EMAIL';
export const VALIDATE_REGEX         = 'VALIDATE_REGEX';
export const VALIDATE_CHECKED       = 'VALIDATE_CHECKED';
export const VALIDATE_UNCHECKED     = 'VALIDATE_UNCHECKED';
export const VALIDATE_URL           = 'VALIDATE_URL';
export const VALIDATE_CUSTOM        = 'VALIDATE_CUSTOM';

export let validators = {
	VALIDATE_NOT_EMPTY: (val) => !!(val.length),
	VALIDATE_MAX_LENGTH: (val, max) => (val.length <= max),
	VALIDATE_MIN_LENGTH: (val, min) => (val.length >= min),
	VALIDATE_EQUALS_FIELD: (val, fieldFn) => {
		if (typeof fieldFn === 'function' && fieldFn()) {
			let fldVal = fieldFn().value;

			if (typeof fldVal === 'function') {
				fldVal = fieldFn().value();
			}

			return (val === fldVal);
		}

		return true;
	},
	VALIDATE_EQUALS: (val, val2) => (val === val2),
	VALIDATE_EMAIL: (val) => (/\S+@\S+/.test(val)),
	VALIDATE_CHECKED: (val) => !!val,
	VALIDATE_UNCHECKED: (val) => !val,
	VALIDATE_CUSTOM: (val, func) => func(val),
	VALIDATE_REGEX: (val, regex) => {
		if (regex.hasOwnProperty('test')) {
			return regex.test(val);
		}

		return true;
	},

	VALIDATE_URL: (val) => {
		return (
			!val.length ||
			/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:ww‌​w.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?‌​(?:[\w]*))?)/.test(val)
		);
	}

};

export function formIsValid(fields) {
	let valid = true;
	for (let i = 0; i < fields.length; i++) {
		if (typeof fields[i].testValidity !== 'function') {
			console.log(fields[i]);
		}
		if ((typeof fields[i].testValidity === 'function') && !fields[i].testValidity()) {
			valid = false;
		}
	}

	return valid;
};

export function isValid(value, validatorsToRun, errorOverride = false) {
	let valid = true;

	if (!errorOverride && validatorsToRun && validatorsToRun.length) {
		valid = ((val) => {
			// run though enabled validators from props
			for (let i = 0; i < validatorsToRun.length; i++) {
				// if the validator exists
				if (validators.hasOwnProperty(validatorsToRun[i].rule)) {
					// run the validator with its options -- if any validator fails return invalid/false
					let validate = validators[validatorsToRun[i].rule];
					if (typeof validate === 'function' && !validate(val, validatorsToRun[i].params)) {
						return false;
					}
				}
			}

			return true;
		})(value);

		return valid;
	} else {
		return !errorOverride;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/validate.js
 **/